import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoRevenueForm from '@/components/forms/NpoRevenueForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { RevenueData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const Revenue = () => {
  const { state: authState } = useAuth();
  const { state: npoScreensState, setCurrentPage } = useNpoLoginScreenState();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) authState.signUpData?.loginEmail?.type === 'CHURCH' ? setCurrentPage(2) : setCurrentPage(3);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoScreensState.initialNpoData ?? '');

  const onSubmit = async (data: RevenueData) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          revenue: data.revenue,
          totalExpenses: data.totalExpenses
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                revenue: true
              },
              {
                onSuccess: () => {
                  router.navigate('/(app)/login/nonProfit/onBoarding/backgroundChecks');
                }
              }
            );
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoRevenueForm
      nonProfitOrg={nonProfitOrg}
      isLoading={onBoardingIsPending || nonProfitIsPending}
      onSubmitTapped={onSubmit}
    />
  );
};

export default Revenue;
